export const nameReducer = 'auth';
